import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Content, PageHeader, Spinner, AlertBar, Tabs, Tab, TabList, TabContent } from 'scorer-ui-kit';
import LogSettingsTab from './LogSettingsTab';
import LogDownloadTab from './LogDownloadTab';
import { PageHeaderContainer, DeviceNameLabel, Divider, SpinnerDesign, AlertContainer, NoteLabel, CenterAlignedContainer } from '../Style';
import styled from 'styled-components';
import { useDevice } from '../hooks/useDevice';
import { useLocation } from 'react-router-dom';

const TabContentComponent = styled(TabContent)`
  margin-top: 50px;
`;
const TabRow = styled.div`
  display: flex;
`;

function AuditLogs() {
  const { state: { device, status_code, deviceLoading, message }, actions: { fetchDevice } } = useDevice();
  const [alert, setAlert] = useState<{ key?: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });
  const [period, setPeriod] = useState(0);

  const { t } = useTranslation(['AuditLogs', 'Common']);
  const location = useLocation();

  useEffect(() => {
    if (!deviceLoading) { 
      if (status_code === '0') {
        setPeriod(device.audit_keep_days);
      } else if (status_code === '2') {
        setAlert({ key: new Date(), message: t('Common:deviceNotFound'), type: 'info' });
      } else {
        setAlert({ key: new Date(), message: message, type: 'error' });
      }
    }
  }, [device, status_code, deviceLoading, message, t]);

  useEffect(() => {
    fetchDevice();
  }, [fetchDevice]);

  useEffect(() => {
    sessionStorage.removeItem('cameraTab');
    sessionStorage.removeItem('notificatioinTab');
  }, [location]);

  const setLogPeriod = useCallback((logPeriod) => {
    setPeriod(logPeriod);
  }, []);

  return (
    <Content>
      <PageHeaderContainer>
        <PageHeader title={t('auditLogs')} icon='Detection' areaTitle={t('Common:home')} areaHref='/' />
        <DeviceNameLabel htmlFor='' labelText={device.name} />
        <NoteLabel htmlFor='' labelText={device.detail} />
      </PageHeaderContainer>
      {
        deviceLoading ?
          <CenterAlignedContainer>
            <Spinner size='large' styling={SpinnerDesign} />
          </CenterAlignedContainer> :
          (alert.message === '' ?
            <Tabs>
              <TabList defaultTabId={sessionStorage.getItem('auditLogTab') || 'one'}>
                <TabRow>
                  <Tab tabFor='one' onClick={()=>sessionStorage.setItem('auditLogTab','one')}>{t('Common:settings')}</Tab>
                  <Tab tabFor='two' onClick={()=>sessionStorage.setItem('auditLogTab','two')}>{t('download')}</Tab>
                </TabRow>
              </TabList>
              <Divider />
              <TabContentComponent tabId='one'>
                <LogSettingsTab period={period} setLogPeriod={setLogPeriod} />
              </TabContentComponent>
              <TabContentComponent tabId='two'>
                <LogDownloadTab />
              </TabContentComponent>
            </Tabs> :
            <AlertContainer key={alert.key}>
              <AlertBar type={alert.type} message={alert.message} />
            </AlertContainer>)
      }
    </Content>
  );
}
export default AuditLogs;
